export class PageRequestModel {
    page: number;
    pageSize: number;
    sort?: string;
    sortDirection?: string;
    searchTerm?: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/PageRequestModel.ts